
import { Component } from '@angular/core';

import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 's-form-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss'],
  standalone: true,
  imports: [Button]
})
export class DeleteConfirmationPrimeComponent {
  actionName: string;
  objectName: string;
  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig
  ) {
    this.actionName = dialogConfig.data?.action ?? 'Delete';
    //console.log('dialogConfig.data', dialogConfig.data);
    this.objectName = dialogConfig.data.name?.charAt(0).toUpperCase() + dialogConfig.data.name?.slice(1);
    //console.log('data', dialogConfig.data);
  }
  onNoClick(): void {
    this.ref.close(false);
  }
  close(_$event: MouseEvent): void {
    this.ref.close(false);
  }
  confirm(): void {
    this.ref.close(true);
  }
}
